import React from 'react';

const LoginBackground = () => {
  return (
    <div className="absolute top-20 left-10 w-32 h-32 bg-primary/10 rounded-full blur-3xl hidden sm:block">
    <div className="fixed inset-0 -z-10">
      {/* Gradient Background */}
      <div className="absolute inset-0 bg-gradient-to-br from-primary/5 via-background to-accent/5"></div>
      
      {/* Pattern Overlay */}
      <div className="absolute inset-0 opacity-30">
        <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <pattern id="textile-pattern" x="0" y="0" width="60" height="60" patternUnits="userSpaceOnUse">
              <circle cx="30" cy="30" r="1.5" fill="var(--color-primary)" opacity="0.1"/>
              <circle cx="0" cy="0" r="1" fill="var(--color-accent)" opacity="0.05"/>
              <circle cx="60" cy="60" r="1" fill="var(--color-accent)" opacity="0.05"/>
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#textile-pattern)"/>
        </svg>
      </div>

      {/* Decorative Elements */}
      <div className="absolute top-20 left-10 w-32 h-32 bg-primary/10 rounded-full blur-3xl"></div>
      <div className="absolute bottom-20 right-10 w-40 h-40 bg-accent/10 rounded-full blur-3xl"></div>
      <div className="absolute top-1/2 left-1/4 w-24 h-24 bg-success/10 rounded-full blur-2xl"></div>

      {/* Textile Industry Icons */}
      <div className="absolute top-16 right-16 opacity-5">
        <svg width="120" height="120" viewBox="0 0 24 24" fill="var(--color-primary)">
          <path d="M12 2L2 7v10c0 5.55 3.84 9.74 9 11 5.16-1.26 9-5.45 9-11V7l-10-5z"/>
        </svg>
      </div>
      
      <div className="absolute bottom-16 left-16 opacity-5">
        <svg width="100" height="100" viewBox="0 0 24 24" fill="var(--color-accent)">
          <path d="M20 6L9 17l-5-5"/>
        </svg>
      </div>
    </div>
    </div>
  );
};

export default LoginBackground;